import React from 'react';
import { motion } from 'motion/react';
import { Sparkles } from 'lucide-react';

export const SuspenseLoader = () => {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center p-6 space-y-6">
      <div className="relative">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 8, ease: "linear" }}
          className="w-32 h-32 rounded-full border-t-2 border-indigo-600 border-opacity-30 border-dashed"
        />
        <motion.div
          animate={{ rotate: -360 }}
          transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
          className="absolute inset-2 rounded-full border-b-2 border-slate-900 border-opacity-20 border-dotted"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <motion.div
            animate={{ scale: [1, 1.2, 1], opacity: [0.5, 1, 0.5] }}
            transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
            className="w-12 h-12 bg-indigo-50 rounded-2xl rotate-45 flex items-center justify-center"
          >
            <Sparkles size={24} className="text-indigo-600 -rotate-45" />
          </motion.div>
        </div>
      </div>
      
      <div className="text-center space-y-2">
        <h2 className="text-sm font-black text-slate-900 uppercase tracking-[0.2em]">Loading Module</h2>
        <p className="text-xs text-slate-500 font-bold uppercase tracking-widest">Optimizing resources...</p>
      </div>
    </div>
  );
};
